import React from 'react';
import styled from 'styled-components';
import { H2, P3 } from '../../Atoms/Typo';
import BarChart from '../../Molecule/Chart/BarChart';
import Count from '../../Molecule/Count/NumberToKorean';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: white;
  width: 100%;
  height: 100%;
`;

const Body = styled.div`
  flex: 1;
  width: 100%;
  margin-bottom: 40px;
`;

const Title = styled.div`
  ${P3};
  color: ${(props) => props.theme.colors.grey500};
`;

const Value = styled.div`
  margin-top: 4px;
  ${H2};
  color: ${(props) => props.theme.colors.grey800};
  .voda_num_to_kor_count {
    ${H2};
    color: ${(props) => props.theme.colors.grey800};
  }
`;

const Desc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
  ${P3};
  color: ${(props) => props.theme.colors.grey600};
`;

interface BarChartCardProps {
  title: string;
  value: number;
  desc: string;
  data: {
    [key: string]: number | boolean;
    isHighlight: boolean;
  }[];
  isLabelInChart: boolean;
  isTime?: boolean;
}

const BarChartCard = ({
  title,
  value,
  desc,
  data,
  isLabelInChart,
  isTime,
}: BarChartCardProps) => {
  const convertSec = (sec: number) => {
    const cvMin = Math.floor(sec / 60);
    const cvSec = Math.floor(sec % 60);

    if (cvMin === 0) {
      return `${cvSec}초`;
    }
    return `${cvMin}분 ${cvSec}초`;
  };

  return (
    <Component>
      <Body>
        <BarChart data={data} isLabelInChart={false} isTime={isTime} />
      </Body>
      <Title>{title}</Title>

      {isLabelInChart ? (
        <Value>상위 {value}%</Value>
      ) : (
        <Value>{isTime ? convertSec(value) : <Count value={value} />}</Value>
      )}
      <Desc>
        {desc.split(`\n`).map((line) => {
          return <div key={line}>{line}</div>;
        })}
      </Desc>
    </Component>
  );
};

export default BarChartCard;
